'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("documentEditionPopinController", function ($scope, $http, $dateFormat, $q, lovService, $applications) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.aideSubventionApplication = $applications.isAideSubventionApplication();
  $scope.typesDocumentsEcheancesIds = [];
  $q.when(lovService.getTypesDocumentsEcheancesProduitsFinanciers()).then(function (typesDocumentEcheance) {
    $scope.typesDocumentsEcheancesIds = _.map(typesDocumentEcheance, function (t) {
      return t.id;
    });
    $scope.$watch('document', function (d) {
      if (!d.tags) {
        d.tags = {};
      }
      if (!$scope.typesDocumentsEcheancesIds.includes(d.type)) {
        d.tags.DATE_ECHEANCE = null;
      }
    }, true);
  });
  $scope.dateEcheances = [];
  if (!$scope.aideSubventionApplication) {
    $http.get("/rest/fiche/echeancier/" + $scope.produitId + "/datesEcheances").then(function (response) {
      $scope.dateEcheances = _.map(response.data, function (date) {
        return {
          'date': $dateFormat.serverShort(date),
          'label': $dateFormat.short(date)
        };
      });
    });
  }
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.label = $scope.document.label ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.type = $scope.document.type ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.url = $scope.document.url === "" ? {
      message: "Champ obligatoire"
    } : undefined;
    if (!$scope.errors.label && !$scope.errors.type && !$scope.errors.url) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/documents/documentEditionPopin.js
// module id = 2826
// module chunks = 13